import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import 'PointOfSale/styles/components/pageFooter.less';

const ServingOptionFooterComponent = props => {
  const { handleOnClick } = props;
  return (
    <span className="continue-action">
      <Button primary size="large" onClick={handleOnClick}>
        <Button.Content>
          Start Serving <Icon name={'forward'} />
        </Button.Content>
      </Button>
    </span>
  );
};

export default ServingOptionFooterComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/ServingOptionFooter.js